import { useQuery } from 'react-query';

import { useUser } from '~/features/user/hooks/use-user';

import { getEnrollmentsProgress } from '../controllers/get-enrollments-progress';

export function useEnrollmentsProgress() {
  const { userId, jwt } = useUser();

  const {
    data: enrollmentsProgress,
    error: enrollmentsProgressError,
    isLoading: enrollmentsProgressIsLoading,
    isFetched: enrollmentsProgressIsFetched,
  } = useQuery('enrollment-progress', () => getEnrollmentsProgress(jwt!), {
    enabled: Boolean(userId) && Boolean(jwt),
  });

  return {
    enrollmentsProgress,
    enrollmentsProgressError,
    enrollmentsProgressIsLoading,
    enrollmentsProgressIsFetched,
  };
}
